import { useEffect } from "react";

// Deterrent-only: blocks right-click, common devtools shortcuts, view-source and copy.
// NOTE: Client-side code can never be fully hidden in a browser; this only stops casual users.
export function useProtect() {
  useEffect(() => {
    const allowInput = (el) => {
      const t = (el?.tagName || "").toLowerCase();
      return t === "input" || t === "textarea" || el?.isContentEditable;
    };

    const onContextMenu = (e) => { e.preventDefault(); };

    const onKeyDown = (e) => {
      const k = (e.key || "").toLowerCase();
      // F12
      if (e.key === "F12") { e.preventDefault(); return; }
      // Ctrl/Cmd + Shift + I / J / C  (devtools)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && ["i", "j", "c"].includes(k)) { e.preventDefault(); return; }
      // Ctrl/Cmd + U (view source)
      if ((e.ctrlKey || e.metaKey) && k === "u") { e.preventDefault(); return; }
      // Ctrl/Cmd + S (save page)
      if ((e.ctrlKey || e.metaKey) && k === "s") { e.preventDefault(); return; }
      // Ctrl/Cmd + C / X / A / P outside of inputs
      if ((e.ctrlKey || e.metaKey) && ["c", "x", "a", "p"].includes(k) && !allowInput(e.target)) {
        e.preventDefault();
      }
    };

    const blockClipboard = (e) => { if (!allowInput(e.target)) e.preventDefault(); };
    const onDragStart = (e) => { e.preventDefault(); };

    document.addEventListener("contextmenu", onContextMenu);
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("copy", blockClipboard);
    document.addEventListener("cut", blockClipboard);
    document.addEventListener("dragstart", onDragStart);

    return () => {
      document.removeEventListener("contextmenu", onContextMenu);
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("copy", blockClipboard);
      document.removeEventListener("cut", blockClipboard);
      document.removeEventListener("dragstart", onDragStart);
    };
  }, []);
}
